module.exports = __webpack_public_path__ + "static/media/brush-alt.10128d96.svg";